export enum IndeedIntegrationStatus {
    Complete = 'complete',
    Incomplete = 'incomplete',
}
